import { defineMessages } from 'react-intl';

export const DetailsDescriptions = defineMessages({
  title: {
    id: 'app.DetailsDescriptions.title',
    defaultMessage: 'Detaily nového měřidla',
  },
  commodity: {
    id: 'app.common.commodity',
  },
  installationStatus: {
    id: 'app.common.installationStatus',
    defaultMessage: 'Stav osazení',
  },
  meterMountTechnology: {
    id: 'app.common.meterMountTechnology',
    defaultMessage: 'Technologie osazení',
  },
  note: {
    id: 'app.ServiceInspection.note',
    defaultMessage: 'Poznámka',
  },
});

export const NewValuesDescriptions = defineMessages({
  serialNumber: {
    id: 'app.common.serialNumber',
    defaultMessage: 'Sériové číslo',
  },
  manufacturer: {
    id: 'app.common.manufacturer',
    defaultMessage: 'Výrobce',
  },
  meterModel: {
    id: 'app.common.meterModelLabel',
    defaultMessage: 'Model měřidla',
  },
  manufactured: {
    id: 'app.Select.manufacturedLabel',
    defaultMessage: 'Rok výroby měřidla',
  },
  calibrated: {
    id: 'app.Select.calibratedLabel',
    defaultMessage: 'Rok cejchování měřidla',
  },
  registerName: {
    id: 'app.common.registerName',
    defaultMessage: 'Nazev registru {register}',
  },
  registerStatus: {
    id: 'app.common.registerStatusWithValue',
    defaultMessage: 'Stav registru {register}',
  },
  registerPhotos: {
    id: 'app.common.registerPhotosWithValue',
    defaultMessage: 'Fotky odečtu registru {register}',
  },
  newMeter: {
    id: 'app.common.newMeter',
    defaultMessage: 'Nové měřidlo',
  },
});

export const OldValuesDescriptions = defineMessages({
  title: {
    id: 'app.OldValuesDescriptions.title',
    defaultMessage: 'Původní měřidlo',
  },
  replacementDateAndTime: {
    id: 'app.common.replacementDateAndTimeLabel',
    defaultMessage: 'Datum a čas výměny',
  },
  serialNumber: {
    id: 'app.common.serialNumber',
    defaultMessage: 'Sériové číslo',
  },
  registerName: {
    id: 'app.common.registerName',
    defaultMessage: 'Nazev registru {register}',
  },
  registerStatus: {
    id: 'app.common.registerStatus',
    defaultMessage: 'Stav registru',
  },
  registerPhotos: {
    id: 'app.common.registerPhotos',
    defaultMessage: 'Fotky odečtu registru',
  },
});

export const ReviewStepContent = defineMessages({
  recordSentSuccess: {
    id: 'app.common.recordSentSuccess',
    defaultMessage: 'Záznam byl úspěšně odeslán',
  },
  recordSentError: {
    id: 'app.common.recordSentError',
    defaultMessage: 'Při odesílání záznamu došlo k chybě',
  },
  queuedMetersSentSuccess: {
    id: 'app.common.queuedMetersSentSuccessReplacement',
    defaultMessage: 'Výměna uložena, nezapomeňte ji odeslat na server pomocí synchronizačního tlačítka',
  },
});

export const ReviewStepFooter = defineMessages({
  back: {
    id: 'app.common.back',
    defaultMessage: 'Zpět',
  },
  sending: {
    id: 'app.common.sending',
    defaultMessage: 'Odesílám...',
  },
  confirm: {
    id: 'app.common.confirm',
    defaultMessage: 'Potvrdit',
  },
});
